// extracted by mini-css-extract-plugin
export default {"category":"Category_category__EJliZ"};